<template>

  <b-col>
    <h1>Звонки</h1>
    <b-overlay :show="loading">

      <div class="mb-4">
        <CallFilter :query="query" @search="onSearch" />
      </div>
    </b-overlay>

    <b-overlay :show="loading">

      <KeysetPagination
        v-if="calls.length"
        routeName="call-list"
        :routeParams="params"
        :prevId="prevId"
        :nextId="nextId"
        :query="query"
      />

      <b-card
        class="my-3"
        v-for="call in calls" :key="call.id"
      >
        <b-media
          vertical-align="center">

          <template v-slot:aside>
            <div v-if="call.direction == 'incoming'" class="d-flex flex-column align-items-center">
              <b-avatar variant="info" size="lg">
                <fa-icon icon="arrow-right" />
              </b-avatar>
              <small class="mt-2 text-muted">Входящий</small>
            </div>
            <div v-else class="d-flex flex-column align-items-center">
              <b-avatar variant="primary" size="lg">
                <fa-icon icon="arrow-left" />
              </b-avatar>
              <small class="mt-2 text-muted">Исходящий</small>
            </div>
          </template>

          <div class="d-flex justify-content-between">

            <div>
              <p class="text-secondary">
                <span title="Начат"><fa-icon icon="calendar-plus"></fa-icon> {{ fmtDate(call.date_started) }}</span>&nbsp;
                <fa-icon v-if="call.date_finished" icon="arrow-right" class="ml-2" />&nbsp;
                <span v-if="call.date_finished" class="ml-2" title="Закончен"><fa-icon icon="calendar-check"></fa-icon> {{ fmtDate(call.date_finished) }}</span>
                <span v-if="call.duration" class="ml-3" title="Время разговора"><fa-icon class="text-secondary" icon="clock"></fa-icon> {{ call.duration.format('mm:ss') }}</span>
              </p>

              <h4>
                <b-badge title="Исходящий номер" :variant="call.direction == 'incoming' ? 'light' : 'info'">{{ formatPhone(call.from_number) }}</b-badge> <fa-icon icon="arrow-right" class="ml-2" /> <b-badge class="ml-2" title="Входящий номер" :variant="call.direction == 'incoming' ? 'info' : 'light'">{{ formatPhone(call.to_number) }}</b-badge>
              </h4>
            </div>

            <div class="d-flex flex-column align-items-right text-right justify-content-between">
              <h5>
                <b-badge :variant="callStatus(call.status).color">{{ callStatus(call.status).label }}</b-badge>
              </h5>
              <div v-if="call.recording_status === 'downloaded'" class="d-flex flex-row align-items-center" >
                <audio v-show="playing.has(call.id)" :ref="'recording' + call.id" controls preload="none">
                  <source :src='call.recording_url' type='audio/mp3' />
                </audio>

                <b-button-group size="sm" class="ml-3">
                  <b-button variant="outline-primary" title="Прослушать" @click.stop.prevent="play(call.id)">
                    <fa-icon icon="play" />
                  </b-button>
                  <b-button variant="outline-info" title="Загрузить" :download="call.date_started + '.mp3'" target="_blank" :href="call.recording_url">
                    <fa-icon icon="download" />
                  </b-button>
                </b-button-group>
              </div>
              <small class="text-muted">ID: {{ call.id }}</small>
            </div>
          </div>

        </b-media>
      </b-card>

      <p class="lead" v-if="!calls.length && !loading">Нет звонков</p>

      <KeysetPagination
        v-if="calls.length"
        routeName="call-list"
        :routeParams="params"
        :prevId="prevId"
        :nextId="nextId"
        :query="query"
      />

    </b-overlay>
  </b-col>

</template>

<script>
import moment from 'moment';

import { store } from "@/store";
import Api from "@/lib/Api";
import Utils from "@/lib/Utils";
import KeysetPagination from "@/components/KeysetPagination.vue";
import CallFilter from "@/components/CallFilter.vue";


export default {
    name: 'CallList',
    props: [
        'projectId'
    ],
    components: {
        KeysetPagination,
        CallFilter
    },
    data () {
        return {
            loading: false,
            calls: [],
            playing: new Set(),
            appState: store.state,
            prevId: null,
            nextId: null
        };
    },
    created () {
        this.loadData();
    },
    watch: {
        '$route': 'loadData'
    },
    computed: {
        query () {
            return Object.assign({}, this.$route.query);
        },
        params () {
            return Object.assign({}, this.$route.params);
        }
    },
    methods: {
        play (callId) {
            this.playing = new Set(this.playing.add(callId));
            this.$refs['recording' + callId][0].play();
        },
        onSearch (filter) {
            this.$router.push({
                name: 'call-list',
                params: this.params,
                query: filter
            }).catch(e => {
                if (e && e.name != "NavigationDuplicated") {
                    throw e;
                }
                return true;
            }); 
        },
        async loadData () {
            this.loading = true;
            try {
                const resp = await Api.getCalls(parseInt(this.projectId),
                                                this.$route.query);
                this.calls = resp.calls.map((c) => {
                    if (c.date_started)
                        c.date_started = moment(c.date_started);
                    if (c.date_finished) {
                        c.date_finished = moment(c.date_finished);
                        c.duration = moment.utc(c.date_finished.diff(c.date_started));
                    }
                    return c;
                });
                this.prevId = resp.pagination.prev_id;
                this.nextId = resp.pagination.next_id;
            } catch (e) {
                console.error(e);
                this.$bvToast.toast('Ошибка загрузки звонков', {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        },
        ...Utils
    }
};

</script>
